import api from './interceptor';

const BASE_URL_V2 = 'api/v2/rpm-patient';

export default {
  // API Version 2
  getActualRPM: patientId => api.get(`${BASE_URL_V2}/actual-rpm/${patientId}`),
};
